import React from 'react';
import { useNavigate } from 'react-router-dom';
import PortalHeader from './PortalHeader';
import { C2ProfileUI } from './C2ProfileUI';
import { useC2ProfileData } from '../../hooks/useC2ProfileData';
import './C2Profile.css';

const C2Profile: React.FC = () => {
  const navigate = useNavigate();
  const profileData = useC2ProfileData();

  const handleLogout = () => {
    navigate('/login');
  };

  const handleBackClick = () => {
    navigate('/portal/records');
  };

  const handleDownloadPDF = () => {
    alert('📥 Downloading certificate PDF...');
  };

  const handlePrint = () => {
    alert('🖨️ Opening print dialog...');
  };

  const handleEmail = () => {
    alert('📧 Opening email dialog...');
  };

  const handleRequestReScreening = () => {
    alert('🔄 Re-screening requested successfully');
  };

  return (
    <div className="portal-container">
      <PortalHeader onLogout={handleLogout} />
      <C2ProfileUI
        profileData={profileData}
        onBackClick={handleBackClick}
        onDownloadPDF={handleDownloadPDF}
        onPrint={handlePrint}
        onEmail={handleEmail}
        onRequestReScreening={handleRequestReScreening}
      />
    </div>
  );
};

export default C2Profile;
